







































import { computed, defineComponent, ref, onMounted, watch } from '@vue/composition-api';
import CouponTab from './coupon-tab.vue';
import CouponList from './coupon-list.vue';
import CouponListV3 from './coupon-list-v3.vue';
import ThemeNotice from '@/components/common/theme-notice.vue';
import HeaderMini from '@/components/header-module/header-mini.vue';
import { BounceContainer } from '@tencent/wphk-ui';
import BottomTips from './bottom-tips.vue';
import GoTop from './go-top.vue';
import { getElementTop } from '@/utils';
import { useGrayStore } from '@/store/gray';
import { useMiniHeader } from '@/hooks/use-mini-header';
import { i18n } from '@/i18n';
import { useElementVisibility } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import { useTabStore } from '@/store/tab';
import { throttle } from 'lodash-es';
import { biBrow } from '@tencent/fit-bi-sdk';
import { useCouponTaskDialog } from '@/hooks/use-coupon-task-dialog';

export default defineComponent({
  name: 'CouponModule',
  props: {},
  components: { CouponTab, CouponList, CouponListV3, ThemeNotice, HeaderMini, BounceContainer, BottomTips, GoTop },
  setup() {
    // 外部进入页面或者从 banner 点击时候的券 tab
    const { couponDetailTab } = useCouponTaskDialog();
    const { isGrayUser } = storeToRefs(useGrayStore());

    const tabStore = useTabStore();
    const { currentTabKey, tabTips, tabConfig } = storeToRefs(tabStore);

    const split = ref<HTMLElement | null>(null);
    /** mini版header */
    const header = ref<HTMLElement | null>(null);
    /** tab */
    const tab = ref<InstanceType<typeof CouponTab> | null>(null);
    /** mini版标题样式 */
    const { style: miniHeaderStyle, isCompeleteFixed, headerHeight, tabHeight } = useMiniHeader({
      headerEl: header,
      // @ts-ignore
      tabEl: tab,
    });

    const couopnListV3 = ref<InstanceType<typeof CouponListV3> | null>(null);
    const onClickTab = () => {
      if (!isGrayUser.value) {
        if (isCompeleteFixed.value) { // 只有完全吸顶时，才重置滚动
          const splitTop = getElementTop(split.value!);
          const scrollTop = splitTop - headerHeight.value - tabHeight.value;
          window.scrollTo(0, scrollTop + 2);
        }
      } else {
        // 滚动到对应位置
        couopnListV3.value?.scrollToPosition(currentTabKey.value, headerHeight.value + tabHeight.value);
      }
    };
    const bottomTipsEl = ref<HTMLElement | null>(null);
    /** 是否启用伤滑切换tab效果，当底部提示出现时才启用 */
    const isEnableBounce = useElementVisibility(bottomTipsEl);
    const bottomTips = computed(() => ({
      tips: tab.value?.hasNextTab ? i18n('繼續上滑查看更多優惠') : i18n('更多優惠敬請期待'),
      isShowIcon: tab.value?.hasNextTab,
    }));
    const handleBounceScrollEnd = () => {
      tab.value?.goNextTab();
      console.log('tab.value?.hasNextTab: ', tab.value);
    };
    const handleClickGoTop = () => {
      window.scrollTo(0, 0);
    };

    // 用户向下滑动的距离
    const userStartY = ref(0);
    const userMoveY = ref(0);
    // 使用throttle函数包装函数，限制函数执行频率为500ms
    const handleUserTouchmoveThrottle = throttle(handleUserTouchmove, 500);
    // 当用户滑动距离超过一个卡片高度时，上报一次
    function handleUserTouchmove() {
      const distanceY = Math.abs(userMoveY.value - userStartY.value);
      if (isGrayUser.value && distanceY >= 200) {
        biBrow('rewards.scroll_over_one', { fcouponVersion: 'new' });
      } else if (!isGrayUser.value && distanceY >= 200) {
        biBrow('rewards.scroll_over_one', { fcouponVersion: 'old' });
      }
    }
    onMounted(() => {
      window.addEventListener('touchstart', (event) => {
        userStartY.value = event.touches[0].clientY;
      });
      window.addEventListener('touchmove', (event) => {
        userMoveY.value = event.touches[0].clientY;
        handleUserTouchmoveThrottle();
      });

      // 监听全局的券弹窗，即banner 拉起的券或者 url 带 couponId 的券，自动定位到 tab（旧版）或者券（新版）
      watch(
        () => couponDetailTab.value,
        (newValues) => {
          if (newValues) {
            tab.value?.onClickTab(newValues);
          }
        },
      );
    });

    return {
      isGrayUser,
      currentTabKey,
      tabConfig,
      onClickTab,
      header,
      split,
      tab,
      miniHeaderStyle,
      tabTips,
      bottomTips,
      isHeaderCompeleteFixed: isCompeleteFixed,
      handleBounceScrollEnd,
      handleClickGoTop,
      bottomTipsEl,
      isEnableBounce,
      couopnListV3,
    };
  },
});
